import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  makeStyles,
} from '@material-ui/core';
import { ArrowForward, ArrowBack } from '@material-ui/icons';
import './Certificates.css';

const useStyles = makeStyles((theme) => ({
  arrowIcon: {
    color: theme.palette.text.primary,
    transition: 'color 0.3s ease',
  },
}));

export const Certificates = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const totalCertificates = 11;
  const scrollRef = useRef(null);

  const certificates = Array.from({ length: totalCertificates }, (_, index) => ({
    id: index + 1,
    title: `Certificate ${index + 1}`,
    description: `Description of Certificate ${index + 1}`,
    imageUrl: `/certs/c${index + 1}.webp`,
    thumbnailUrl: `/certs/c${index + 1}.webp`,
  }));

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const navigate = (direction) => {
    setAutoPlay(false);
    if (direction === 'next') {
      setCurrentImageIndex((prev) => (prev + 1) % certificates.length);
    } else {
      setCurrentImageIndex((prev) => (prev - 1 + certificates.length) % certificates.length);
    }
  };

  useEffect(() => {
    if (!autoPlay) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % certificates.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [autoPlay, certificates.length]);

  return (
    <section id="certificates" className="certificates-section">
      <Typography variant="h3" component="h2" gutterBottom>
        CERTIFICATES
      </Typography>

      <div className="certificates-wrapper">
        <div className="certificates-list" ref={scrollRef}>
          <div className="certificates-thumbnails">
            {certificates.map((cert, index) => (
              <div
                key={cert.id}
                className={`thumbnail-item ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => {
                  setCurrentImageIndex(index);
                  setAutoPlay(false);
                }}
              >
                <img
                  src={cert.thumbnailUrl}
                  alt={`Thumbnail ${cert.id}`}
                  className="thumbnail-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div
          className="preview-container"
          onMouseEnter={() => setAutoPlay(false)}
          onMouseLeave={() => setAutoPlay(true)}
        >
          <IconButton
            onClick={() => navigate('prev')}
            className="preview-nav-btn"
            aria-label="Previous certificate"
          >
            <ArrowBack
              fontSize={isMobile ? 'small' : 'medium'}
              className={classes.arrowIcon}
            />
          </IconButton>

          <img
            src={certificates[currentImageIndex].imageUrl}
            alt={`Certificate ${certificates[currentImageIndex].title}`}
            className="preview-image"
            loading="eager"
          />

          <IconButton
            onClick={() => navigate('next')}
            className="preview-nav-btn"
            aria-label="Next certificate"
          >
            <ArrowForward
              fontSize={isMobile ? 'small' : 'medium'}
              className={classes.arrowIcon}
            />
          </IconButton>
        </div>
      </div>
    </section>
  );
};
